import React from 'react'
import moment from 'moment'
import { useScopedDate } from '../../../features/time-date/use-scoped-date'

const ScopedDate = ({
    value,
    invalidLabel = ''
}) => {
  const date = useScopedDate({
    date: value,
    invalidLabel
  });
  return (
    <React.Fragment>
      {date}
    </React.Fragment>
  );
  /*
    const date = moment(value)
    console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
    if (!date.isValid()) {
        return (<React.Fragment>{invalidLabel}</React.Fragment>)
    }
    const duration = moment.duration(moment().diff(date))
    const hours = duration.as('hours')

    if (hours < 24 ) {
        return (
            <React.Fragment>{date.format('h:mm A')}</React.Fragment>
        )
    }

    const days = duration.as('days')
    
    if (days < 7) {
        return (
            <React.Fragment>{date.format('ddd h:mm A')}</React.Fragment>
        )
    }

    return (
        <React.Fragment>
            {date.format('MMM D, YYYY, h:mm A')}
        </React.Fragment>
    )
        */
}

export default ScopedDate
